import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useFilterContext } from "../head-bar/filter-context";
import { TagGroup } from "./group";
import { Cuisines } from "./cuisines";
import Loading from "../../components/dc-loading";
import Skeleton from "./skeleton";
import { observer } from "mobx-react-lite";

export const AllFilter = observer(({ setOpen }) => {
  const {
    fakeState,
    setFakeState,
    cleanFakeState,
    setState,
    filterParams,
    loading,
    paramsLoading,
    total,
    setIsInFakeMode,
  } = useFilterContext();
  const { t } = useTranslation();

  const toggle = (id, key) => {
    setFakeState((prev) => {
      const val = prev[key] || [];
      if (val === id) {
        return { [key]: "" };
      }
      return { [key]: id };
    });
  };

  function onOK() {
    setOpen("");
    setState({ ...fakeState });
    setIsInFakeMode(false);
  }

  function handleCleanFakeState() {
    cleanFakeState();
  }

  const okText = useMemo(() => {
    if (loading) {
      return <Loading></Loading>;
    }
    if (!total) {
      return t("Header.No results");
    }
    return t("Header.See {count}", { count: total });
  }, [loading, total, t]);

  return (
    <div className="head-filter__all">
      {paramsLoading && (
        <div className="head-filter__scroll-area">
          {[1, 2, 3, 4, 5].map(() => (
            <Skeleton></Skeleton>
          ))}
        </div>
      )}

      <div className="head-filter__scroll-area">
        <div id="scroll-filters"></div>
        <TagGroup
          title={t("Header.Recommended")}
          list={filterParams.tags}
          name="tags.id"
          styles={{ marginTop: 0 }}
        />
        <div className="head-filter-group">
          <div className="head-filter-title">{t("Browse.price_range")}</div>
          <div className="head-filter-list">
            {filterParams.price_range.map((item, index) => {
              let val = [item.start_price, item.end_price].join(",");
              return (
                <div
                  className={cn("filter__tag", {
                    "filter__tag--active": fakeState.avg_price === `${val}`,
                  })}
                  key={index}
                  onClick={() => toggle(val, "avg_price")}
                >
                  {item.view_price}
                </div>
              );
            })}
          </div>
        </div>
        <div id="scroll-location"></div>
        <div className="head-filter-group">
          <div className="head-filter-title">{t("Browse.distance")}</div>
          <div className="head-filter-list">
            {filterParams.distance.map((item, index) => {
              let val = item + "m";
              return (
                <div
                  className={cn("filter__tag", {
                    "filter__tag--active": fakeState.distance === `${val}`,
                  })}
                  key={index}
                  onClick={() => toggle(val, "distance")}
                >
                  {`< ${item}m`}
                </div>
              );
            })}
          </div>
        </div>
        <TagGroup
          title={t("Browse.district")}
          list={filterParams.locations}
          name="location.id"
        />
        <TagGroup
          title={t("Browse.landmarks")}
          list={filterParams.landmarks}
          name="landmarks.id"
        />
        <div id="scroll-cuisines"></div>
        <Cuisines />
        <TagGroup
          title={t("Browse.tags")}
          list={filterParams.extras}
          name="extras.id"
        />
        <div style={{ height: "40vh" }}></div>
      </div>
      <div className="head-filter__all-foot">
        <span className="ui-button" onClick={handleCleanFakeState}>
          {t("Header.Clear all filters")}
        </span>
        <span
          className={cn("ui-button", {
            "ui-button--disabled": !total && !loading,
          })}
          type="primary"
          onClick={onOK}
        >
          {okText}
        </span>
      </div>
    </div>
  );
});
